module.exports = __webpack_public_path__ + "img/gin.83f65c6f.svg";